import { faNumber } from '../../lib/faNumbers'
import styles from './ItemRow.module.css'

export type ItemSyncState = 'synced' | 'queued' | 'failed'

interface ItemRowProps {
  index: number
  serialNumber: string
  state: ItemSyncState
  onRemove: () => void
}

const CHIP: Record<ItemSyncState, { label: string; className: string }> = {
  synced: { label: 'ثبت شد', className: styles.chipSynced },
  queued: { label: 'در صف', className: styles.chipQueued },
  failed: { label: 'ناموفق', className: styles.chipFailed },
}

export function ItemRow({ index, serialNumber, state, onRemove }: ItemRowProps) {
  const chip = CHIP[state]

  return (
    <div className={styles.row}>
      <span className={styles.index}>{faNumber(index)}</span>
      <span className={styles.serial}>{serialNumber}</span>
      <span className={`${styles.chip} ${chip.className}`}>{chip.label}</span>
      <button
        type="button"
        className={styles.remove}
        onClick={onRemove}
        aria-label={`حذف ${serialNumber}`}
      >
        ✕
      </button>
    </div>
  )
}
